export const COUPONS_LANGUAGE = {
  // add coupon
  coupons_title_add: "Add Coupon",
  coupons_add_name: "Name",
  coupons_add_name_error: "Coupon name is required field",
  coupons_add_name_limit_error: "Character must be smaller then 50",
  coupons_add_discount_type: "Discount type",
  coupons_add_discount_type_error: "Discount type is required field",
  coupons_add_discount: "Discount",
  coupons_add_discount_error: "Discount is required field",
  coupons_add_discount_min_error: "Discount should be greater than 0",
  coupons_add_discount_Decimal_not_allowed: "Discount should not decimal value",
  coupons_add_max_usage: "Maximum usage",
  coupons_add_max_usage_error: "Maximum usage is required field",
  coupons_add_max_usage_min_error: "Maximum usage should be greater than 0",
  coupons_add_max_usage_per_user: "Maximum usage per user",
  coupons_add_max_usage_per_user_error: "Maximum usage per user is required field",
  coupons_add_max_usage_per_user_min_error: "Maximum usage per user should be greater than 0",
  coupons_add_max_discount_amount: "Maximum Discount Amount",
  coupons_add_max_discount_amount_error: "Maximum Discount Amount is required field",
  coupons_add_max_discount_amount_min_error: "Maximum Discount Amount should be greater than 0",
  coupons_add_description: "Description",
  coupons_add_description_error: "Description is required field",
  coupons_add_code: "Coupon code",
  coupons_add_code_error: "Coupon code is required field",
  coupons_add_start_date: "Start Date",
  coupons_add_start_date_error: "Start Date is required field",
  coupons_add_end_date: "End Date",
  coupons_add_end_date_error: "End Date is required field",
  coupons_add_end_date_greater_error: "End date must be a greater than or equal to start date",
  coupons_add_status: "Status",
  coupons_add_status_error: "Status is required field",

  // view coupon
  coupons_view_name: "Coupon Name",
  coupons_view_discount_type: "Discount Type",
  coupons_view_description: "Description",
  coupons_view_discount: "Discount",
  coupons_view_max_discount_amount: "Max Allowed Discount Amount",
  coupons_view_code: "Code",
  coupons_view_max_allowed_usage: "Max Allowed Usage",
  coupons_view_max_allowed_usage_per_user: "Max Allowed Usage Per User",
  coupons_view_start_date: "Start Date",
  coupons_view_end_date: "End Date",
  coupons_view_created_by: "Created By",
  coupons_view_updated_by: "Updated By",
  coupons_view_created_at: "Created At",
  coupons_view_updated_at: "Updated At",
  coupons_view_isActive: "Status",
  coupons_view_top_bar_search: "Search",
  coupons_view_list: "Coupons List"
};
